"use client";
import "react";
import { Chart as a, BarController as r, LineController as e, CategoryScale as o, LinearScale as t, BarElement as i, PointElement as m, LineElement as s, Title as l, Tooltip as n, Legend as p, Filler as f } from "./index.es68.js";
import g from "./index.es69.js";
import C from "./index.es70.js";
import E from "./index.es71.js";
import L from "./index.es65.js";
import c from "./index.es72.js";
L.div`
  position: relative;
  min-height: 500px;
`;
a.register(
  r,
  e,
  g,
  E,
  o,
  t,
  i,
  m,
  s,
  l,
  n,
  p,
  f,
  C,
  c
);
a.defaults.font.size = 16;
//# sourceMappingURL=index.es33.js.map
